import { ChallengeActivity, ImageUpload } from '../../types';
import { LitElement, css, html } from 'lit';
import { cancelDefault, isDefined } from '../../helpers/utils';
import { customElement, property, state } from 'lit/decorators';

import { moveItem } from '../../helpers/tags-categories';

@customElement('challenge-activity-wrapper')
export class ChallengActivityWrapper extends LitElement {
    static amplitude_callsite: string = 'Edit Challenge Activity Drawer';

    @property()
    data: ChallengeActivity[] = [];

    @property()
    images: Array<ImageUpload | undefined> = [];

    @property()
    dataAction: Function = () => {};

    @property()
    updateData: Function = () => {};

    @property()
    activeData?: ChallengeActivity;

    @property()
    hideNames: boolean = false;

    @state()
    showNewActivity: boolean = false;

    newAward() {
        this.dispatchEvent(new CustomEvent('new-activity'));
    }

    protected render() {
        return html`
            <div class="awards__draggable-container">
                ${this.data.map(
                    (c, index) => {
                        const image = this.images[index];
                        const image_url = isDefined(image) ? URL.createObjectURL(image.file) : c.image_url;
                        return html`
                            <button draggable="true"
                                @dragstart="${(e: DragEvent) => this.handleDragStart(e)}"
                                @drop="${(e: DragEvent) => this.handlePillDrop(e)}"
                                @dragenter="${(e: DragEvent) => this.handleDragEnter(e)}"
                                @dragleave="${(e: DragEvent) => this.handleDragLeave(e)}"
                                @dragend="${(e: DragEvent) => this.handleDragEnd(e)}"
                                @dragover="${(e: DragEvent) => cancelDefault(e)}"
                                @click="${() => this.handleClick(c, index)}"
                                ?disabled="${this.activeData && this.activeData !== c}"
                                index="${index}"
                                class="awards__item ${c === this.activeData ? 'active' : ''}"
                            >
                                <img draggable="false" class="awards__item--image" src="${image_url}" width="16" height="16">
                                ${this.hideNames ? '' : c.name ?? ''}
                            </button>
                        `;
                    }
                )}
                ${this.showNewActivity ? html`
                    <button
                        class="new-award awards__item"
                        @click="${this.newAward}"
                    >
                        <b>+ Add New Activity</b>
                    </button>
                ` : ''}
            </div>
            <error-toast id="errorToast"></error-toast>
        `;
    }

    static get styles() {
        return css`
            .awards__item {
                background-color: white;
                border: 1px solid lightgray;
                border-radius: 50px;
                padding: 2px 8px;
                margin: 4px;
                cursor: grab;
                filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25));
            }

            .awards__item.over {
                outline: 2px dotted #666;
            }

            .awards__item.awards__item--group {
                background-color: #EFECF3;
            }

            .awards__item.active {
                border: 3px solid var(--main-primary-color);
            }

            .awards__item--image {
                vertical-align: text-bottom;
            }

            .awards__draggable-container {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                border-radius: 4px;
            }

            button {
                display: flex;
                flex-direction: row;
                align-items: center;
            }


        `;
    }

    handleClick(data: ChallengeActivity, index: number) {
        this.dispatchEvent(new CustomEvent('dataAction', {
            bubbles: true,
            composed: true,
            detail: {
                data,
                index,
            }
        }));
    }

    handleDragStart(e: any) {
        e.target.style.opacity = '0.4';
        e.dataTransfer?.setData('text', e.target?.getAttribute('index'));
        e.dataTransfer.dropEffect = 'move';
    }

    handleDragEnter(e: any) {
        e.target.classList.add('over');
        cancelDefault(e);
    }

    handleDragLeave(e: any) {
        e.target.classList.remove('over');
        cancelDefault(e);
    }

    handleDragEnd(e: any) {
        e.target.style.opacity = '1';
        cancelDefault(e);
    }

    handlePillDrop(e: any) {
        e.target.classList.remove('over');

        const droppedElementIndex = e.dataTransfer?.getData('text');
        const newElementIndex = e.target.getAttribute('index');
        const reorderedData = moveItem(this.data, droppedElementIndex, newElementIndex);

        this.dispatchEvent(new CustomEvent('updateData', {
            bubbles: true,
            composed: true,
            detail: {
                data: reorderedData,
                oldIndex: droppedElementIndex,
                newIndex: newElementIndex
            }
        }));

        cancelDefault(e);
    }
}
